<div class="mb-2" *ngIf="displayLanguage">
  <div class="flex-label" style="margin-bottom: 0.15rem">
    <label
      for="language"
      class="form-label label d-flex"
      style="align-items: center; margin-bottom: 0"
    >
      <span>Language</span>
    </label>
  </div>
</div>
<div
  class="mb-2 d-flex flex-row align-items-center gap-2"
  *ngIf="displayLanguage"
>
  <ng-select
    [items]="languages"
    bindLabel="name"
    bindValue="code"
    placeholder="Select Language"
    [(ngModel)]="data.language"
    [searchable]="true"
    [clearable]="true"
    [virtualScroll]="true"
    (change)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
  <ng-template ngOption let-item="item" (click)="$event.stopPropagation();chooseModel(item)">
    {{ item.name }}
  </ng-template>
  </ng-select>
</div>
<div class="mb-2" *ngIf="displayModel">
  <div class="flex-label" style="margin-bottom: 0.15rem">
    <label
      for="llmModel"
      class="form-label label d-flex"
      style="align-items: center; margin-bottom: 0"
    >
      <span>Model</span>
      <nb-icon
        class="ms-1"
        style="color: #929bb3; width: 15px"
        nbTooltip="Select the model used to retrieve the answer from the LLM service."
        nbTooltipPlacement="bottom"
        nbTooltipStatus="basic"
        nbTooltipTrigger="hover"
        icon="question-mark-circle-outline"
      >
      </nb-icon>
    </label>
  </div>
</div>
<div class="mb-2 d-flex flex-row align-items-center gap-2" *ngIf="displayModel">
  <nb-select
    fullWidth
    size="small"
    placeholder="Select Model"
    [(ngModel)]="data.llmModel"
    class="llm-select"
  >
    <nb-option-group title="Open AI" (click)="chooseModel($event)">
      <nb-option value="gpt-3.5-turbo" (click)="chooseModel($event)"
        >gpt-3.5-turbo</nb-option
      >
      <nb-option value="gpt-4o-mini" (click)="chooseModel($event)"
        >gpt-4o-mini</nb-option
      >
      <nb-option value="gpt-4o" (click)="chooseModel($event)">gpt-4o</nb-option>
    </nb-option-group>
    <nb-option-group title="Ollama" (click)="chooseModel($event)">
      <nb-option value="llama3" (click)="chooseModel($event)">llama3</nb-option>
    </nb-option-group>
  </nb-select>
  <button
    nbButton
    size="small"
    (click)="toggleAdvanced()"
    ghost
    nbTooltip="Advance settings"
    nbTooltipPlacement="bottom"
    status="primary"
  >
    <nb-icon icon="options-2-outline"></nb-icon>
  </button>
</div>

<nb-accordion style="border: none !important">
  <nb-accordion-item #advanced>
    <nb-accordion-item-body class="mb-2">
      <!-- Temperature -->
      <div>
        <label class="form-label label d-flex mb-0" style="align-items: center"
          ><span>Temperature</span>
          <nb-icon
            class="ms-1"
            style="width: 15px"
            nbTooltip="What sampling temperature to use, between 0 and 1. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic."
            nbTooltipPlacement="bottom"
            nbTooltipStatus="basic"
            icon="question-mark-circle-outline"
          >
          </nb-icon
        ></label>
        <div class="d-flex">
          <mat-slider
            min="0"
            max="1"
            step="0.1"
            [(ngModel)]="data.temperature"
            (input)="setTemperature(durationT.value)"
            #durationT
          >
            <input matSliderThumb />
          </mat-slider>
          <input
            type="text"
            nbInput
            maxlength="3"
            fieldSize="tiny"
            style="
              width: 4rem;
              text-align: center;
              align-self: center;
              height: fit-content;
            "
            [(ngModel)]="data.temperature"
            (blur)="handleMaxValueTemperature($event)"
          />
          <!-- <label class="form-label label">{{ data.temperature }}</label> -->
        </div>
      </div>
      <!-- Max length -->
      <div>
        <label class="form-label label d-flex mb-0" style="align-items: center"
          ><span>Maximum Length</span>
          <nb-icon
            class="ms-1"
            style="width: 15px"
            nbTooltip="The maximum number of tokens to generate in the completion."
            nbTooltipPlacement="bottom"
            nbTooltipStatus="basic"
            icon="question-mark-circle-outline"
          >
          </nb-icon
        ></label>
        <div class="d-flex">
          <mat-slider
            min="0"
            max="4000"
            step="1"
            [(ngModel)]="data.numberOutput"
            (input)="setNumberOutput(numberOutput.value)"
            #numberOutput
          >
            <input matSliderThumb />
          </mat-slider>
          <input
            type="text"
            nbInput
            maxlength="4"
            fieldSize="tiny"
            style="
              width: 4rem;
              text-align: center;
              align-self: center;
              height: fit-content;
            "
            [(ngModel)]="data.numberOutput"
            (blur)="handleMaxValueNumberOutput($event)"
          />
        </div>
      </div>
      <!-- top P -->
      <div>
        <label class="form-label label d-flex mb-0" style="align-items: center"
          ><span>Top P</span>
          <nb-icon
            class="ms-1"
            style="width: 15px"
            nbTooltip="An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered."
            nbTooltipPlacement="bottom"
            nbTooltipStatus="basic"
            icon="question-mark-circle-outline"
          >
          </nb-icon
        ></label>
        <div class="d-flex">
          <mat-slider
            min="0"
            max="1"
            step="0.01"
            [(ngModel)]="data.topP"
            (input)="setTopP(topP.value)"
            #topP
          >
            <input matSliderThumb />
          </mat-slider>
          <input
            type="text"
            nbInput
            maxlength="3"
            fieldSize="tiny"
            style="
              width: 4rem;
              text-align: center;
              align-self: center;
              height: fit-content;
            "
            [(ngModel)]="data.topP"
            (blur)="handleMaxValueTopP($event)"
          />
          <!-- <label class="form-label label">{{ data.temperature }}</label> -->
        </div>
      </div>
      <!-- Frequency Penalty -->
      <div>
        <label class="form-label label d-flex mb-0" style="align-items: center">
          <span>Frequency Penalty</span>
          <nb-icon
            class="ms-1"
            style="width: 15px"
            nbTooltip="Positive values penalize new tokens based on their existing frequency in the text so far, decreasing the model's likelihood to repeat the same line verbatim."
            nbTooltipPlacement="bottom"
            nbTooltipStatus="basic"
            icon="question-mark-circle-outline"
          >
          </nb-icon>
        </label>
        <div class="d-flex">
          <mat-slider
            min="-2"
            max="2"
            step="0.01"
            [(ngModel)]="data.frequencyPenalty"
            (input)="setFrequencyPenalty(durationFP.value)"
            #durationFP
          >
            <input matSliderThumb />
          </mat-slider>
          <input
            type="text"
            nbInput
            maxlength="5"
            fieldSize="tiny"
            style="
              width: 4rem;
              text-align: center;
              align-self: center;
              height: fit-content;
            "
            [(ngModel)]="data.frequencyPenalty"
            (blur)="handleMaxValueFrequencyPenalty($event)"
            (keydown)="blockE($event)"
          />
        </div>
      </div>
      <!-- Presence penalty -->
      <div>
        <label class="form-label label d-flex mb-0" style="align-items: center">
          <span>Presence Penalty</span>
          <nb-icon
            class="ms-1"
            style="width: 15px"
            nbTooltip="Positive values penalize new tokens based on whether they appear in the text so far, increasing the model's likelihood to talk about new topics."
            nbTooltipPlacement="bottom"
            nbTooltipStatus="basic"
            icon="question-mark-circle-outline"
          >
          </nb-icon>
        </label>
        <div class="d-flex">
          <mat-slider
            min="-2"
            max="2"
            step="0.01"
            [(ngModel)]="data.presencePenalty"
            (input)="setPresencePenalty(presencePenalty.value)"
            #presencePenalty
          >
            <input matSliderThumb />
          </mat-slider>
          <input
            type="text"
            nbInput
            maxlength="5"
            fieldSize="tiny"
            style="
              width: 4rem;
              text-align: center;
              align-self: center;
              height: fit-content;
            "
            [(ngModel)]="data.presencePenalty"
            (blur)="handleMaxValuePresencePenalty($event)"
            (keydown)="blockE($event)"
          />
        </div>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<div class="mb-2" *ngIf="displayKnowledge">
  <div class="mb-2">
    <label
      for="topK"
      class="form-label label d-flex"
      style="align-items: center"
    >
      <span>Top K</span>
      <nb-icon
        class="ms-1"
        style="color: #929bb3; width: 15px"
        nbTooltip="This option will get the number of segments and returns to the LLM(1). The minimum value is 1 and the maximum value is 10."
        nbTooltipPlacement="bottom"
        nbTooltipStatus="basic"
        nbTooltipTrigger="hover"
        icon="question-mark-circle-outline"
      ></nb-icon
    ></label>
    <input
      id="topK"
      [(ngModel)]="data.topK"
      type="number"
      min="0"
      nbInput
      fullWidth
      placeholder="Number of segments and returns to the LLM"
      fieldSize="small"
      (keydown.enter)="validateTopK()"
      (blur)="validateTopK()"
      (keydown)="blockE($event, true, true)"
    />
  </div>

  <div class="mb-2">
    <label class="form-label label d-flex mb-0" style="align-items: center"
      ><span>Similarity Cutoff</span>
      <nb-icon
        class="ms-1"
        style="width: 15px"
        nbTooltip="The similarity between segments and user input."
        nbTooltipPlacement="bottom"
        nbTooltipStatus="basic"
        icon="question-mark-circle-outline"
      >
      </nb-icon
    ></label>
    <div class="d-flex">
      <mat-slider
        min="1"
        max="100"
        step="1"
        [(ngModel)]="data.similarityCutOff"
        (input)="setSimilarityCutoff(durationT.value)"
        #durationT
      >
        <input matSliderThumb />
      </mat-slider>
      <div class="d-flex flex-row gap-1 align-items-center">
        <input
          type="text"
          nbInput
          maxlength="3"
          fieldSize="tiny"
          style="
            width: 4rem;
            text-align: center;
            align-self: center;
            height: fit-content;
          "
          [(ngModel)]="data.similarityCutOff"
          (input)="handleMaxValueSimilarityCutoff($event)"
          (keydown)="blockE($event, true)"
        />
        <nb-icon
          icon="percent-outline"
          status="primary"
          style="font-size: 1rem"
        ></nb-icon>
      </div>
    </div>
  </div>
</div>
<label
  class="form-label label d-flex"
  style="align-items: center"
  *ngIf="displayKnowledge && displayNotMatch"
>
  <span>Not Match Reply</span>
  <nb-icon
    class="ms-1"
    style="color: #929bb3; width: 15px"
    nbTooltip="The reply if there is no segments match from service."
    nbTooltipPlacement="bottom"
    nbTooltipStatus="basic"
    nbTooltipTrigger="hover"
    icon="question-mark-circle-outline"
  >
  </nb-icon
></label>
<div
  class="d-flex mb-2 justify-content-between align-items-center"
  style="gap: 1.5rem"
  *ngIf="displayKnowledge && displayNotMatch"
>
  <nb-select
    style="flex: 1"
    class=""
    placeholder="Select Reply Type"
    size="small"
    fullWidth
    [(ngModel)]="data.replyType"
  >
    <nb-option
      value="default"
      style="padding-left: 10px !important"
      (click)="chooseModel($event)"
      >LLM Prompt</nb-option
    >
    <nb-option
      value="custom"
      style="padding-left: 10px !important"
      (click)="chooseModel($event)"
      >Not Match Prompt</nb-option
    >
  </nb-select>
</div>
